/* =====================================================================
 * Mr-&-Mrs-Datums-Poster Editor (PROJ-40)
 * =====================================================================
 * Reines Text-Poster (KEIN Foto, KEIN Crop, KEINE Map). Kopiervorlage
 * = geburtsposter.js (State/Live-Preview, Groessen-/Frame-Picker aus
 * target_product.variants, Cart-Add).
 *
 * PRINT-MATCH: Die Live-Vorschau spiegelt renderMrMrs() aus
 * citymap-server/blanket_frontend/print-mode.js 1:1 (gleiche Positionen,
 * cqw-Groessen). Aendert sich der Server, muss dieser Block mitgezogen
 * werden - Werte bewusst identisch.
 *
 * Layout: Datum vertikal als drei Serif-Ziffernbloecke (TT/MM/JJ,
 * Preset-Farbe, z-index 2), Script-Woerter word1/&/word2 an FESTEN
 * %-Ankern versetzt darueber (z-index 3 - Verschraenkung ueber Layering,
 * NIE ueber Verschieben der Ziffern, Playbook §3). Hero-Verschraenkung
 * NICHT umschaltbar (§6). Unten Namen (Pflicht) + Ort (optional).
 * Die Ziffernbloecke gehen als fertige Strings (digits[]) an den Server.
 * ===================================================================== */

(function () {
  'use strict';

  var BACKEND_API_URL = window.MM_BACKEND_API_URL || 'https://tiles.distantlines.de';

  /* ---- Geteilte Layout-Konstanten (MUESSEN dem Server entsprechen) ---- */
  var INK = '#28292d';
  var SANS = "'Outfit', system-ui, sans-serif";
  /* Stil-Fonts Modern/Elegant/Verspielt - 1:1 vom Definitionsposter (Hauptwort).
   * MUESSEN print-mode.js entsprechen (Print-Match). Clother/Parlare via Typekit
   * sgc6idq, Playfair via Google. Parlare NUR Weight 400 (Glyphen-Bug). */
  var PW_STYLES = {
    modern:    { font: "'clother', sans-serif",              weight: 700 },
    elegant:   { font: "'Playfair Display', Georgia, serif", weight: 700 },
    verspielt: { font: "'parlare', cursive",                 weight: 400 }
  };
  var PW_LABEL = { modern: 'Modern', elegant: 'Elegant', verspielt: 'Verspielt' };
  function pwFont(s) { return PW_STYLES[s] || PW_STYLES.elegant; }
  /* Referenz-Muster (Dominik 18.07., Etsy-Vorbild): Ziffern in Linotype
   * Didot (Haarlinien-Didone, edler als Playfair 600), enger Stapel weit
   * oben, word1 in Luecke 1, & in Luecke 2, word2 UNTER Block 3
   * (Dominiks Korrektur 18.07. abends - urspruengliches Muster). */
  var DIGIT_FONT = "'linotype-didot', 'Playfair Display', Georgia, serif";
  var DIGIT_Y = [18, 40, 62];
  var DIGIT_SIZE = 26;
  var WORD_ANCHORS = [
    { x: 31, y: 29, size: 13 },     // word1 (Luecke Block 1+2, links versetzt)
    { x: 50, y: 51, size: 10 },     // & (Luecke Block 2+3, mittig)
    { x: 67, y: 73, size: 13 }      // word2 (UNTER Block 3, rechts versetzt)
  ];

  /* ---- Modul-State (eine Section pro -gestalten-Page) ---- */
  var root, stage, sectionId;
  var state = {
    fstyle: { words: 'verspielt' },
    date: '2026-08-20',        // YYYY-MM-DD (Date-Picker)
    word1: 'Mr',
    word2: 'Mrs',
    names: 'Sophie & Daniel',
    ort: 'Braunschweig',
    digit_color: '#e3d4bd',    // Preset Beige = Default
    c_script: '#28292d',
    c_footer: '#28292d',
    bg_color: '#ffffff',
    paper_size: '30x40',
    variant_id: '',
    product_type: '',
    frame_color: 'brown'
  };

  /* Datum -> drei 2-stellige Bloecke (TT/MM/JJ, fuehrende Nullen) */
  function dateDigits() {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(state.date || '');
    if (!m) return ['20', '08', '26'];
    return [m[3], m[2], m[1].slice(2)];
  }

  /* Woerter: nur Buchstaben (inkl. Umlaute/ß), Punkt, Bindestrich - Emoji &
   * Sonderzeichen fallen raus (Font-Sicherheit, Edge-Case aus der Spec). */
  function sanitizeWord(v) {
    return (v || '').replace(/[^A-Za-zÄÖÜäöüß.\- ]/g, '').slice(0, 6);
  }

  /* ===================================================================
   * Render-Bausteine - 1:1-Spiegel von jgText/jgFit (Server print-mode.js)
   * =================================================================== */
  function mmText(grid, o) {
    if (o.content == null || String(o.content).trim() === '') return null;
    var el = document.createElement('div');
    el.className = 'text-slot';
    el.textContent = o.content;
    var css = 'position:absolute;z-index:6;' +
      'left:' + (o.x != null ? o.x : 50) + '%;top:' + o.y + '%;transform:translate(-50%,-50%);' +
      'display:flex;align-items:center;justify-content:center;text-align:center;' +
      'font-family:' + o.font + ';font-weight:' + (o.weight || 400) + ';' +
      'font-size:' + o.size + 'cqw;color:' + (o.color || INK) + ';line-height:' + (o.lh || 1.15) + ';white-space:nowrap;';
    if (o.upper) css += 'text-transform:uppercase;';
    if (o.spacing) css += 'letter-spacing:' + o.spacing + ';';
    el.style.cssText = css;
    grid.appendChild(el);
    return el;
  }

  function mmFit(el, maxPct) {
    if (!el) return;
    var avail = stage.clientWidth * (maxPct / 100);
    var guard = 0;
    while (el.scrollWidth > avail && guard < 40) {
      var cur = parseFloat(getComputedStyle(el).fontSize);
      if (!cur || cur < 2) break;
      el.style.fontSize = (cur * 0.96) + 'px';
      guard++;
    }
  }

  /* ===================================================================
   * Live-Render - 1:1-Spiegel von renderMrMrs() (Server)
   * =================================================================== */
  function render() {
    if (!stage) return;
    var grid = document.createElement('div');
    grid.className = 'collage-grid no-panel';
    grid.style.setProperty('--blanket-color', state.bg_color);
    grid.style.backgroundColor = state.bg_color;

    var digits = dateDigits();

    // ---- Drei Ziffernbloecke (Serif, Preset-Farbe, HINTER den Woertern) ----
    digits.forEach(function (d, i) {
      var el = mmText(grid, {
        content: d, x: 50, y: DIGIT_Y[i], font: DIGIT_FONT, weight: 400, size: DIGIT_SIZE,
        color: state.digit_color, lh: 1, spacing: '0.06em'
      });
      if (el) el.style.zIndex = 2;
    });

    // ---- Script-Woerter an festen Ankern UEBER den Ziffern ----
    var words = [sanitizeWord(state.word1) || 'Mr', '&', sanitizeWord(state.word2) || 'Mrs'];
    var wordEls = words.map(function (w, i) {
      var a = WORD_ANCHORS[i];
      var el = mmText(grid, {
        content: w, x: a.x, y: a.y, font: pwFont(state.fstyle.words).font, weight: pwFont(state.fstyle.words).weight, size: a.size,
        color: state.c_script || INK, lh: 1
      });
      if (el) el.style.zIndex = 3;
      return el;
    });

    // ---- Namen (Pflicht) + Ort (optional, Zeile entfaellt) ----
    var elNames = mmText(grid, { content: state.names, x: 50, y: 86.5, font: "'Playfair Display', Georgia, serif", weight: 600, size: 3.2, color: state.c_footer || INK, upper: true, spacing: '0.24em' });
    var elOrt = mmText(grid, { content: state.ort, x: 50, y: 90.5, font: SANS, weight: 500, size: 2.1, color: state.c_footer || INK, upper: true, spacing: '0.20em' });

    stage.innerHTML = '';
    stage.appendChild(grid);

    wordEls.forEach(function (el) { mmFit(el, 46); });  // Wortbreiten-Skalierung (AK Mrs&Mrs)
    mmFit(elNames, 88);
    mmFit(elOrt, 90);
  }

  /* ===================================================================
   * Eingaben
   * =================================================================== */
  function bindField(id, key, sanitize) {
    var el = document.getElementById(id);
    if (!el) return;
    if (el.value != null) state[key] = sanitize ? sanitize(el.value) : el.value;
    var apply = function () {
      var v = sanitize ? sanitize(el.value) : el.value;
      if (sanitize && v !== el.value) el.value = v;
      state[key] = v;
      render();
    };
    el.addEventListener('input', apply);
    el.addEventListener('change', apply);
  }

  function initWordPresets() {
    var w1 = document.getElementById('mm-word1');
    var w2 = document.getElementById('mm-word2');
    root.querySelectorAll('.mm-preset-chips [data-w1]').forEach(function (c) {
      c.addEventListener('click', function (e) {
        e.preventDefault();
        state.word1 = c.getAttribute('data-w1');
        state.word2 = c.getAttribute('data-w2');
        if (w1) w1.value = state.word1;
        if (w2) w2.value = state.word2;
        render();
      });
    });
  }

  function initStylePickers() {
    root.querySelectorAll('.pw-style-row[data-style-target]').forEach(function (row) {
      var target = row.getAttribute('data-style-target');
      var btns = row.querySelectorAll('.pw-style-btn[data-style]');
      var cur = row.querySelector('.pw-style-btn.current[data-style]');
      if (cur) state.fstyle[target] = cur.dataset.style;
      btns.forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          btns.forEach(function (x) { x.classList.remove('current'); });
          b.classList.add('current');
          state.fstyle[target] = b.dataset.style;
          render();
        });
      });
    });
  }

  function initColorPickers() {
    root.querySelectorAll('.mm-color[data-key]').forEach(function (p) {
      if (p.value) state[p.dataset.key] = p.value;
      p.addEventListener('input', function () { state[p.dataset.key] = p.value; render(); });
    });
  }

  function initPresetSwatches() {
    var swatches = root.querySelectorAll('.mm-preset[data-color]');
    swatches.forEach(function (s) {
      s.addEventListener('click', function (e) {
        e.preventDefault();
        swatches.forEach(function (x) { x.classList.remove('current'); });
        s.classList.add('current');
        state.digit_color = s.getAttribute('data-color');
        render();
      });
    });
    var active = root.querySelector('.mm-preset.current[data-color]');
    if (active) state.digit_color = active.getAttribute('data-color');
  }

  function initPaperColor() {
    var swatches = root.querySelectorAll('.mm-paper[data-color]');
    function setPaper(hex) {
      state.bg_color = hex;
      swatches.forEach(function (s) {
        s.classList.toggle('current', (s.getAttribute('data-color') || '').toLowerCase() === hex.toLowerCase());
      });
      render();
    }
    swatches.forEach(function (s) {
      s.addEventListener('click', function (e) { e.preventDefault(); setPaper(s.getAttribute('data-color')); });
    });
  }

  /* Info-Gluehbirne (Stadt-/Sternkarten-Muster, .tab-help) */
  function initTabHelp() {
    root.querySelectorAll('.tab-help').forEach(function (help) {
      var toggle = help.querySelector('.tab-help__toggle');
      var content = help.nextElementSibling;
      if (!toggle || !content || !content.classList.contains('tab-help__content')) return;
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var open = content.style.display === 'none' || content.style.display === '';
        content.style.display = open ? 'block' : 'none';
        toggle.classList.toggle('is-active', open);
      });
      var close = content.querySelector('.tab-help__close a');
      if (close) {
        close.addEventListener('click', function (e) {
          e.preventDefault();
          content.style.display = 'none';
          toggle.classList.remove('is-active');
        });
      }
    });
  }

  /* Tabs (Design / Produkt) - main__switcher-Konvention (editor-tabs.css) */
  var formatDefaulted = false;
  function initTabSwitching() {
    var tabs = root.querySelectorAll('.main__switcher > ul > li > a[data-tab]');
    var panels = ['text__wrapper', 'produkt__wrapper'];
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        var target = tab.dataset.tab;
        tabs.forEach(function (t) { t.classList.remove('current'); });
        tab.classList.add('current');
        panels.forEach(function (cls) {
          var el = root.querySelector('.' + cls);
          if (el) el.style.display = (cls === target) ? '' : 'none';
        });
        // Produkt-Tab-Default (Dominik 21.07.): erster Klick -> Holzrahmen (data-id=2);
        // Schwarz + 50x70 sind im Markup bereits .current, fallen damit automatisch.
        if (target === 'produkt__wrapper' && !formatDefaulted) {
          formatDefaulted = true;
          var framed = root.querySelector('.tab__switcher a[data-id="2"]:not(.current)');
          if (framed) framed.click();
        }
        // Mobiles Hochscrollen zur Tab-Leiste (nur <=991px), alle Optionen sichtbar.
        if (window.matchMedia('(max-width: 991px)').matches) {
          var sw = tab.closest('.main__switcher');
          if (sw) sw.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }
  function initWeiterNav() {
    root.querySelectorAll('.weiter-btn[data-target-tab]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var link = root.querySelector('.main__switcher > ul > li > a[data-tab="' + btn.dataset.targetTab + '"]');
        if (link) link.click();
      });
    });
  }

  /* ===================================================================
   * Produkt-Tab - 1:1 Geburtsposter-/Fotoposter-Schema
   * =================================================================== */
  function parsePosterDim(label) {
    var m = /([0-9]+)\s*x\s*([0-9]+)/i.exec(label || '');
    return m ? { w: parseInt(m[1], 10), h: parseInt(m[2], 10) } : { w: 30, h: 40 };
  }
  function formatPrice(cents) {
    return (parseInt(cents, 10) / 100).toFixed(2).replace('.', ',');
  }
  function syncStageToSize() {
    if (!stage || !state.paper_size) return;
    var d = parsePosterDim(state.paper_size);
    var shortE = Math.min(d.w, d.h), longE = Math.max(d.w, d.h);
    stage.style.setProperty('--collage-aspect', shortE + ' / ' + longE);
    var flat = stage.closest('.mm-stage-flat');
    if (flat) flat.style.width = 'calc(min(78vh, 680px) * ' + (shortE / longE) + ')';
    render();
  }
  function syncVariantFromSize(a) {
    state.paper_size = a.getAttribute('data-size') || '';
    state.variant_id = a.getAttribute('data-variant-id') || '';
    var variantInput = document.getElementById('mm-variant-id-' + sectionId);
    if (variantInput && state.variant_id) variantInput.value = state.variant_id;
    var priceEl = root.querySelector('.bottom__controls .variant-price');
    var cents = a.getAttribute('data-price');
    if (priceEl && cents) { priceEl.textContent = formatPrice(cents) + ' €'; priceEl.dataset.price = cents; }
    syncStageToSize();
  }
  function updateFramePreview() {
    if (!stage) return;
    var framed = (state.product_type || '').indexOf('Holzrahmen') !== -1;
    if (framed) { stage.classList.add('has-frame'); stage.setAttribute('data-frame-color', state.frame_color || 'brown'); }
    else { stage.classList.remove('has-frame'); stage.removeAttribute('data-frame-color'); }
  }

  function initFormatPickers() {
    var typeLinks = root.querySelectorAll('.tab__switcher a[data-id]');
    var sizeLinks = root.querySelectorAll('.el__format .size__picker a[data-size]');
    var frameLinks = root.querySelectorAll('a[data-frame-color]');

    typeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        typeLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.product_type = a.getAttribute('data-type') || '';
        var typeId = a.getAttribute('data-id');
        updateFramePreview();
        root.querySelectorAll('.el__format').forEach(function (f) {
          f.style.display = (f.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        root.querySelectorAll('.benefits-box').forEach(function (b) {
          b.style.display = (b.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        var fmt = root.querySelector('.el__format[data-id="' + typeId + '"]');
        if (!fmt) return;
        var ziel = fmt.querySelector('.size__picker a[data-size="' + state.paper_size + '"]') ||
                   fmt.querySelector('.size__picker a.current') ||
                   fmt.querySelector('.size__picker a[data-size]');
        if (ziel) {
          fmt.querySelectorAll('.size__picker a').forEach(function (l) { l.classList.remove('current'); });
          ziel.classList.add('current');
          syncVariantFromSize(ziel);
        }
      });
    });

    sizeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var picker = a.closest('.size__picker');
        picker.querySelectorAll('a').forEach(function (l) { l.classList.remove('current'); });
        a.classList.add('current');
        syncVariantFromSize(a);
      });
    });

    frameLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        frameLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.frame_color = a.getAttribute('data-frame-color');
        updateFramePreview();
      });
    });

    var activeType = root.querySelector('.tab__switcher a.current[data-type]') || typeLinks[0];
    if (activeType) state.product_type = activeType.getAttribute('data-type') || '';
    var activeFrame = root.querySelector('a[data-frame-color].current');
    if (activeFrame) state.frame_color = activeFrame.getAttribute('data-frame-color');
    var visFormat = root.querySelector('.el__format[data-id="1"]');
    var activeSize = visFormat && (visFormat.querySelector('.size__picker a.current') || visFormat.querySelector('.size__picker a[data-size]'));
    if (activeSize) {
      if (!activeSize.classList.contains('current')) activeSize.classList.add('current');
      syncVariantFromSize(activeSize);
    }
    updateFramePreview();
  }

  /* ===================================================================
   * Cart-Add - Muster geburtsposter.js: Render-Job synchron anstossen,
   * dann /cart/add.js mit _print_image_url + Config-Properties.
   * =================================================================== */
  function handleCartAdd() {
    var btn = document.getElementById('mm-cart-btn-' + sectionId);
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(state.date || '');
    if (!m) { alert('Bitte waehle euer Datum.'); return; }
    if (!(state.names || '').trim()) { alert('Bitte gib eure Namen ein.'); return; }
    if (!state.variant_id) { alert('Bitte waehle Produkt und Groesse.'); return; }
    var orig = btn ? btn.textContent : 'In den Warenkorb';
    if (btn) { btn.disabled = true; btn.textContent = 'Wird vorbereitet...'; }

    (async function () {
      try {
        var jobId = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now() + '-' + Math.random().toString(36).slice(2));
        var dim = parsePosterDim(state.paper_size);
        var shortEdge = Math.min(dim.w, dim.h), longEdge = Math.max(dim.w, dim.h);
        var digits = dateDigits();
        var word1 = sanitizeWord(state.word1) || 'Mr';
        var word2 = sanitizeWord(state.word2) || 'Mrs';

        var payload = {
          product: 'mrmrs',
          job_id: jobId,
          variant_id: state.variant_id,
          paper_size: state.paper_size,
          print: { width: shortEdge, height: longEdge, dpi: 300 },
          font_styles: state.fstyle,
          bg_color: state.bg_color,
          digits: digits,
          word1: word1,
          word2: word2,
          names: (state.names || '').trim(),
          ort: (state.ort || '').trim(),
          digit_color: state.digit_color,
          c_script: state.c_script || INK,
          c_footer: state.c_footer || INK
        };

        var printImageUrl = BACKEND_API_URL + '/api/v1/mrmrs/data/' + jobId + '/';
        try {
          var renderResp = await fetch(BACKEND_API_URL + '/api/v1/mrmrs/render/', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
          });
          if (renderResp.ok || renderResp.status === 202) {
            var rd = await renderResp.json().catch(function () { return {}; });
            printImageUrl = rd.print_image_url || printImageUrl;
          }
        } catch (e) { /* Backend nicht erreichbar -> Fallback-URL bleibt */ }

        var props = {
          '_Datum': m[3] + '.' + m[2] + '.' + m[1],
          '_Wörter': word1 + ' & ' + word2,
          '_Namen': (state.names || '').trim(),
          '_job_id': jobId,
          '_print_image_url': printImageUrl,
          '_groesse': state.paper_size,
          '_Stil Mr & Mrs': PW_LABEL[state.fstyle.words] || 'Verspielt',
          '_produkt': 'mrmrs'
        };
        if ((state.ort || '').trim()) props['_Ort'] = state.ort.trim();
        if (state.frame_color && (state.product_type || '').indexOf('Holzrahmen') !== -1) {
          props['_Frame Color'] = state.frame_color;
        }
        Object.keys(props).forEach(function (k) { if (!props[k]) delete props[k]; });

        var cartResp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(state.variant_id, 10), quantity: 1, properties: props }] })
        });
        if (!cartResp.ok) throw new Error('Cart-Add HTTP ' + cartResp.status);

        var cartData = null;
        try {
          cartData = await cartResp.json();
          if (window.DLTrack && window.DLTrack.addToCart) window.DLTrack.addToCart(cartData);
        } catch (e) { /* skip tracking */ }

        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cartData } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') drawer.show();
        else window.location.href = '/cart';
      } catch (err) {
        console.error('[mrmrs] Cart-add failed', err);
        alert('Konnte nicht in den Warenkorb legen - ' + (err.message || 'Unbekannter Fehler'));
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = orig || 'In den Warenkorb'; }
      }
    })();
  }

  /* ===================================================================
   * Init - Input-Values aus dem Markup sind Source of Truth (Playbook §1)
   * =================================================================== */
  function init() {
    root = document.querySelector('.mm-customizer');
    if (!root) return;
    sectionId = root.dataset.sectionId;
    stage = document.getElementById('mm-stage-' + sectionId);

    bindField('mm-date', 'date');
    bindField('mm-word1', 'word1', sanitizeWord);
    bindField('mm-word2', 'word2', sanitizeWord);
    bindField('mm-names', 'names');
    bindField('mm-ort', 'ort');
    initWordPresets();
    initStylePickers();
    initColorPickers();
    initPresetSwatches();
    initPaperColor();
    initTabHelp();
    initTabSwitching();
    initWeiterNav();
    initFormatPickers();

    render();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);

    var btn = document.getElementById('mm-cart-btn-' + sectionId);
    if (btn) btn.addEventListener('click', handleCartAdd);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
